var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.Is_Clickable==1)?_c('router-link',{attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.row.NAME))]):_c('p',[_vm._v(_vm._s(_vm.row.NAME))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }